export default __webpack_public_path__ + "static/media/wedding-ring.cbf1b912.svg";